<div *ngIf="loading$ | async" class="loader-overlay">
  <div class="loader">
  </div>
</div>
